export default __webpack_public_path__ + "static/media/map-dot.d055a142.svg";